import { z } from 'zod'

import { isValidBrandSlug } from '_utils/brand-hint.util'

export const brandPickerSchema = z.object({
  brand: z
    .string()
    .transform((value) => value.trim().toLowerCase())
    .refine(isValidBrandSlug, { message: 'invalidBrand' }),
})

export type BrandPickerValues = z.input<typeof brandPickerSchema>
export type ParsedBrandPickerValues = z.output<typeof brandPickerSchema>
